var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 105,
    viewBox: "0 0 106 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 105C81.9949 105 105.5 81.495 105.5 52.5C105.5 23.5051 81.9949 0 53 0C24.005 0 0.5 23.5051 0.5 52.5C0.5 81.495 24.005 105 53 105Z",
    fill: "#F5F5F5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 35,
    width: 59,
    height: 35,
    rx: 2,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5785 31.1135C84.0321 31.1179 84.4805 31.2116 84.898 31.3893C85.3154 31.5669 85.6938 31.8251 86.0115 32.149C86.3292 32.4729 86.58 32.8562 86.7495 33.277C86.9191 33.6978 87.004 34.1479 86.9996 34.6016V69.7335C87.0019 70.6454 86.6435 71.5212 86.0026 72.1699C85.3617 72.8187 84.4903 73.1877 83.5785 73.1965H23.9212C23.0093 73.1877 22.1379 72.8187 21.497 72.1699C20.8562 71.5212 20.4978 70.6454 20.5 69.7335V34.6016C20.4978 33.6897 20.8562 32.8139 21.497 32.1652C22.1379 31.5165 23.0093 31.1474 23.9212 31.1386L83.5785 31.1135Z",
    stroke: "#572580",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3789 59.311H37.9733",
    stroke: "#572580",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3789 65.1411H53.0465",
    stroke: "#572580",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1621 59.311H50.7565",
    stroke: "#572580",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9434 59.311H63.5377",
    stroke: "#572580",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7324 59.311H76.3268",
    stroke: "#572580",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1385 54.3928H37.8578V52.4856H40.1916C40.7337 52.4834 41.2528 52.2665 41.6353 51.8824C42.0178 51.4983 42.2326 50.9784 42.2326 50.4363V48.3033H43.3451C43.4064 48.3036 43.4667 48.2875 43.5196 48.2566C43.5726 48.2257 43.6163 48.1811 43.6462 48.1276C43.679 48.0764 43.6964 48.0169 43.6964 47.9561C43.6964 47.8953 43.679 47.8358 43.6462 47.7847L41.6638 44.3468C41.6678 44.2827 41.6678 44.2184 41.6638 44.1544C41.6954 43.2629 41.5472 42.3742 41.2279 41.5413C40.9086 40.7084 40.4247 39.9483 39.8053 39.3064C39.1858 38.6646 38.4434 38.1541 37.6223 37.8055C36.8013 37.4568 35.9184 37.2771 35.0264 37.2771C34.1343 37.2771 33.2515 37.4568 32.4304 37.8055C31.6093 38.1541 30.8669 38.6646 30.2475 39.3064C29.628 39.9483 29.1442 40.7084 28.8249 41.5413C28.5055 42.3742 28.3573 43.2629 28.3889 44.1544C28.3854 45.8605 29.0453 47.5013 30.2292 48.7299V54.3928H37.1468H37.1385Z",
    fill: "#F6E71C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/documentIcon.5a4caf7630b42a416f313128b740995f.svg";
export { ForwardRef as ReactComponent };